// import React from "react";
// import { UIInput, UIReactSelect } from "components/Inputfields";

// type SelectOption = { value: string; label: string };

// type Props = {
//   // Titles/labels so the same UI works for Brand or Category
//   title: string;                // e.g., "Add Brand" / "Edit Category"
//   blockTitle: string;           // e.g., "Brand Details" / "Category Details"
//   infoTitle: string;            // e.g., "Brand Information" / "Category Information"
//   imageTitle: string;           // e.g., "Brand Image" / "Category Image"
//   nameLabel?: string;           // defaults to "Name"

//   // Form & actions
//   formik: any;                  // pass your formik instance
//   statusOptions: SelectOption[];
//   submitting: boolean;
//   onBack: () => void;
//   onSubmit: () => void;

//   // Image controls handled by container (so logic can differ)
//   previewUrl?: string | null;
//   onDropFiles: (files: File[]) => void;
//   onPickFile: (file: File | null) => void;
// };

// const SignageBrandCategoryForm: React.FC<Props> = ({
//   title,
//   blockTitle,
//   infoTitle,
//   imageTitle,
//   nameLabel = "Name",
//   formik,
//   statusOptions,
//   submitting,
//   onBack,
//   onSubmit,
//   previewUrl,
//   onDropFiles,
//   onPickFile,
// }) => {
//   return (
//     <div className="content container">
//       <div className="row d-flex justify-content-center">
//         <div className="col-md-8 ">
//           <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }} noValidate>
//             <div className=" mb-4">
//               <h2 className="m-0 ">{title}</h2>
//             </div>
//             <div className="card border rounded-4 shadow-lg overflow-hidden mb-4">
//               <div className="px-4 pt-0 pb-4">
//                 {/* Section header */}
//                 <div className="d-flex align-items-center mb-5" style={{ padding: "25px 18px", borderBottom: "1px solid #eef2f7" }}>
//                   <span className="d-inline-flex align-items-center justify-content-center" style={{ width: 26, height: 26 }}>
//                     <i className="bi bi-tag text-primary" style={{ fontSize: 26, color: "#155dfc", lineHeight: 1 }} />
//                   </span>
//                   <div className="fs-19 roboto-new ms-2">{blockTitle}</div>
//                 </div>

//                 {/* Body */}
//                 <div className="row g-4">
//                   <div className="col-lg-12">
//                     <div className="rounded-4 p-3">
//                       <h5 className="fw-semibold text-dark border-bottom pb-2 mb-3">{infoTitle}</h5>

//                       {/* Name */}
//                       <div className="mb-3" style={{ maxWidth: 640 }}>
//                         <UIInput formik={formik} name="name" label={nameLabel} required placeholder={`Enter ${nameLabel.toLowerCase()}`} />
//                       </div>

//                       {/* Image */}
//                       {/* <div className="mt-3" style={{ maxWidth: 640 }}>
//                     <h5 className="fw-semibold text-dark border-bottom pb-2 mb-3">{imageTitle}</h5>
//                     <div
//                       className="border-1 rounded-4 p-4 text-center"
//                       style={{ borderStyle: "dashed", background: "#fafafa" }}
//                       onDragOver={(e) => e.preventDefault()}
//                       onDrop={(e) => {
//                         e.preventDefault();
//                         const files = Array.from(e.dataTransfer.files || []);
//                         onDropFiles(files as File[]);
//                       }}
//                     >
//                       <div className="mb-2"><i className="bi bi-upload fs-2" /></div>
//                       <div className="mb-1"><span className="fw-semibold">Choose Image</span> or drag and drop</div>
//                       <div className="text-muted small">Upload a square image for best results</div>
//                       <div className="mt-3">
//                         <label className="btn upload-btn mt-2">
//                           Choose Image
//                           <input
//                             type="file"
//                             accept="image/*"
//                             hidden
//                             onChange={(e) => onPickFile(e.target.files?.[0] || null)}
//                           />
//                         </label>
//                       </div>
//                     </div>

//                     {previewUrl && (
//                       <div className="row mt-3" style={{ maxWidth: 480 }}>
//                         <div className="col-md-6 position-relative mb-3">
//                           <div className="border p-2 rounded-3">
//                             <img src={previewUrl} alt="preview" className="img-fluid" style={{ borderRadius: 8 }} />
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </div> */}

//                       {/* Image */}
//                       {/* Image */}
//                       <div className="mt-3" style={{ maxWidth: 640 }}>
//                         <h6 className="form-label mb-2">{imageTitle ?? "Upload Image"}</h6>

//                         {/* hidden input */}
//                         <input
//                           id="image"
//                           name="image"
//                           type="file"
//                           accept="image/*"
//                           className="d-none"
//                           onChange={(e) => onPickFile(e.currentTarget.files?.[0] ?? null)}  // ← use prop
//                           onBlur={formik.handleBlur}
//                         />

//                         <div className="d-flex align-items-center gap-3 mb-3">
//                           {/* dashed square tile (click + drag/drop) */}
//                           <label
//                             htmlFor="image"
//                             className="d-inline-flex align-items-center justify-content-center upload-tile"
//                             title="Upload image"
//                             onDragOver={(e) => e.preventDefault()}
//                             onDrop={(e) => {
//                               e.preventDefault();
//                               const f = e.dataTransfer.files?.[0] ?? null;
//                               if (f) onPickFile(f);   // ← use prop
//                             }}
//                           >
//                             {previewUrl ? (           // ← use previewUrl prop
//                               <img
//                                 src={previewUrl}
//                                 alt="Preview"
//                                 style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 10 }}
//                               />
//                             ) : (
//                               <i className="bi bi-upload fs-4 text-muted" />
//                             )}
//                           </label>

//                           {/* button + helper text */}
//                           <div>
//                             <label htmlFor="image" className="btn upload-ghost d-inline-flex align-items-center">
//                               <i className="bi bi-upload me-2" />
//                               Choose Image
//                             </label>
//                             <div className="text-muted mt-2" style={{ fontSize: 12 }}>
//                               Upload a square image for best results
//                             </div>
//                           </div>
//                         </div>
//                       </div>



//                       {/* Status */}
//                       <div className="mt-3" style={{ maxWidth: 320 }}>
//                         <UIReactSelect formik={formik} name="statuss" label="Status" required placeholder="Select status" options={statusOptions} />
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Footer */}
//                 <div className="row g-4 mt-3">
//                   <div className="col-lg-12">
//                     <div className="rounded-4 p-3">
//                       <hr className=" me-3" />
//                       <div className="d-flex justify-content-between align-items-center ms-1" style={{ padding: "14px 18px" }}>
//                         <button type="button" onClick={onBack} className="btn back-btn surface-btn fw-bold fs-16"
//                         >
//                           <i className="bi bi-chevron-left me-2" /> Back
//                         </button>
//                         <button type="submit" className="btn btn-primary save-btn surface-btn fw-bold fs-16" disabled={submitting}>
//                           {submitting ? "Saving..." : "Save"}
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignageBrandCategoryForm;



import React, { useMemo } from "react";
import { UIInput, UIReactSelect } from "components/Inputfields";
import Select, { MultiValue, GroupBase, StylesConfig ,components} from "react-select";
type SelectOption = { value: string; label: string };

type Props = {
  // Titles/labels so the same UI works for Brand or Category
  title: string;
  blockTitle: string;
  infoTitle: string;
  imageTitle: string;
  nameLabel?: string;

  // Form & actions
  formik: any;
  statusOptions: SelectOption[];
  submitting: boolean;
  onBack: () => void;
  onSubmit: () => void;

  // Image controls handled by container (so logic can differ)
  previewUrl?: string | null;
  onDropFiles?: (files: File[]) => void;
  onPickFile: (file: File | null) => void;

  // ===== Categories (always shown) =====
  categoryOptions?: SelectOption[];
  selectedCategories?: SelectOption[];
  onChangeCategories?: (values: SelectOption[]) => void;
  onClearAllCategories?: () => void;

  // ===== Optional Partnership Configuration props (safe for other logins) =====
  showPartnership?: boolean;                // gate to show/hide the whole section
  partnershipLoading?: boolean;

  brokerageOptions?: SelectOption[];
  agentOptions?: SelectOption[];
  groupOptions?: SelectOption[];

  selectedBrokerages?: SelectOption[];
  selectedAgents?: SelectOption[];
  selectedGroups?: SelectOption[];

  onChangeBrokerages?: (values: SelectOption[]) => void;
  onChangeAgents?: (values: SelectOption[]) => void;
  onChangeGroups?: (values: SelectOption[]) => void;

  onClearAllBrokerages?: () => void;
  onClearAllAgents?: () => void;
  onClearAllGroups?: () => void;

  partnershipSummary?: {
    brokeragesCount: number;
    agentsCount: number;
    groupsCount: number;
    total: number;
  };
  baseRoute?: string;
};

const pcSelectStyles: StylesConfig<SelectOption, true, GroupBase<SelectOption>> = {
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    borderRadius: 12,
    borderColor: state.isFocused ? "#155dfc" : "#e5e7eb",
    boxShadow: state.isFocused ? "0 0 0 4px #e7f0ff" : "none",
    ":hover": { borderColor: state.isFocused ? "#155dfc" : "#cbd5e1" },
    paddingLeft: 6,
    paddingRight: 6,
    fontSize: 14,
  }),
  valueContainer: (base) => ({ ...base, padding: "4px 2px", gap: 6 }),
  placeholder: (base) => ({ ...base, color: "#94a3b8", fontSize: 14 }),
  input: (base) => ({ ...base, fontSize: 14 }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#eef2ff",
    border: "1px solid #dbeafe",
    borderRadius: 20,
    paddingLeft: 8,
    paddingRight: 2,
  }),
  multiValueLabel: (base) => ({ ...base, color: "#1e3a8a", fontWeight: 600, paddingRight: 4 }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#1e3a8a",
    ":hover": { backgroundColor: "transparent", color: "#1d4ed8" },
  }),
  option: (base, state) => ({
    ...base,
    fontSize: 14,
    backgroundColor: state.isSelected
      ? "#eff6ff"
      : state.isFocused
        ? "#f8fafc"
        : undefined,
    color: state.isSelected ? "#1d4ed8" : "#111827",
    ":active": { backgroundColor: "#eff6ff" },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    boxShadow: "0 12px 28px rgba(2,6,23,.08)",
    overflow: "hidden",
    marginTop: 6,
  }),
  menuList: (base) => ({ ...base, padding: 6 }),
  indicatorsContainer: (base) => ({ ...base, paddingRight: 6 }),
  clearIndicator: (base) => ({ ...base, padding: 6 }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    display: state.isDisabled ? "none" : "flex",
  }),
};
const DropdownIndicator = (props: any) => {
  if (props.selectProps.isDisabled) return null;
  return (
    <components.DropdownIndicator {...props}>
      <i className="ri-arrow-down-s-line fs-5" style={{ color: "#6c757d" }} />
    </components.DropdownIndicator>
  );
};


const SignageBrandCategoryForm: React.FC<Props> = ({
  title,
  blockTitle,
  infoTitle,
  imageTitle,
  nameLabel = "Name",
  formik,
  statusOptions,
  submitting,
  onBack,
  onSubmit,
  previewUrl,
  onPickFile,

  // categories (always shown)
  categoryOptions = [],
  selectedCategories = [],
  onChangeCategories,
  onClearAllCategories,

  // partnership (optional)
  showPartnership = false,
  partnershipLoading = false,
  brokerageOptions = [],
  agentOptions = [],
  groupOptions = [],
  selectedBrokerages = [],
  selectedAgents = [],
  selectedGroups = [],
  onChangeBrokerages,
  onChangeAgents,
  onChangeGroups,
  onClearAllBrokerages,
  onClearAllAgents,
  onClearAllGroups,
  partnershipSummary,
  baseRoute,
}) => {
  return (
    <div className="content container">
      <div className="row d-flex justify-content-center">
        <div className="col-md-8 ">
          <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }} noValidate>
            <div className=" mb-4">
              <h2 className="m-0 ">{title}</h2>
            </div>

            <div className="card border rounded-4 shadow-lg overflow-hidden mb-4">
              <div className="px-4 pt-0 pb-4">
                {/* ===== Header ===== */}
                <div className="d-flex align-items-center mb-5" style={{ padding: "25px 18px", borderBottom: "1px solid #eef2f7" }}>
                  <span className="d-inline-flex align-items-center justify-content-center" style={{ width: 26, height: 26 }}>
                    <i className="bi bi-tag text-primary" style={{ fontSize: 26, color: "#155dfc", lineHeight: 1 }} />
                  </span>
                  <div className="fs-19 roboto-new ms-2">{blockTitle}</div>
                </div>

                {/* ===== Body ===== */}
                <div className="row g-4">
                  <div className="col-lg-12">
                    <div className="rounded-4 p-3">
                      <h5 className="fw-semibold text-dark border-bottom pb-2 mb-3">{infoTitle}</h5>

                      {/* Name */}
                      <div className="mb-3 col-md-6" >
                        <UIInput formik={formik} name="name" label={nameLabel} required placeholder={`Enter ${nameLabel.toLowerCase()}`} />
                      </div>
  
                    {/* {(baseRoute === "/signageteammember" || baseRoute === "/signage") && ( */}
                    {!( blockTitle ===  "Category Details") && (
                      <div className="mb-3 col-lg-6">
                        <label className="form-label pc-label">Select Categories</label>

                        <Select
                          name="__categories"
                          isMulti
                          options={categoryOptions || []}
                          value={selectedCategories || []}
                          onChange={(vals) => {
                            // console.log("📝 Categories selected:", vals); // Debug log
                            onChangeCategories?.((vals as MultiValue<SelectOption>) as SelectOption[]);
                          }}
                          placeholder="Choose categories"
                          styles={pcSelectStyles}
                          components={{ DropdownIndicator }}
                          classNamePrefix="rs"
                          isSearchable
                          closeMenuOnSelect={false}
                        />

                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="small text-muted">
                            Selected categories ({(selectedCategories || []).length})
                          </div>
                          {onClearAllCategories && (
                            <button type="button" className="btn btn-link p-0 pc-clear" onClick={onClearAllCategories}>
                              <i className="bi bi-trash me-1" /> Clear All
                            </button>
                          )}
                        </div>

                        {!!(selectedCategories || []).length && (
                          <div className="d-flex flex-wrap gap-2 mt-2">
                            {(selectedCategories || []).map((o) => (
                              <span key={o.value} className="pc-chip">{o.label}</span>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                    {/* // )} */}

                      {/* Image */}
                      <div className="mt-3" style={{ maxWidth: 640 }}>
                        <h6 className="form-label mb-2">{imageTitle ?? "Upload Image"}</h6>

                        {/* hidden input */}
                        <input
                          id="image"
                          name="image"
                          type="file"
                          accept="image/*"
                          className="d-none"
                          onChange={(e) => onPickFile(e.currentTarget.files?.[0] ?? null)}
                          onBlur={formik.handleBlur}
                        />

                        <div className="d-flex align-items-center gap-3 mb-3">
                          {/* dashed square tile (click + drag/drop) */}
                          <label
                            htmlFor="image"
                            className="d-inline-flex align-items-center justify-content-center upload-tile"
                            title="Upload image"
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => {
                              e.preventDefault();
                              const f = e.dataTransfer.files?.[0] ?? null;
                              if (f) onPickFile(f);
                            }}
                          >
                            {previewUrl ? (
                              <img
                                src={previewUrl}
                                alt="Preview"
                                style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 10 }}
                              />
                            ) : (
                              <i className="bi bi-upload fs-4 text-muted" />
                            )}
                          </label>

                          {/* button + helper text */}
                          <div>
                            <label htmlFor="image" className="btn upload-ghost d-inline-flex align-items-center">
                              <i className="bi bi-upload me-2" />
                              Choose Image
                            </label>
                            <div className="text-muted mt-2" style={{ fontSize: 12 }}>
                              Upload a square image for best results
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Status */}
                      <div className="mt-3" style={{ maxWidth: 320 }}>
                        <UIReactSelect
                          formik={formik}
                          name="statuss"
                          label="Status"
                          placeholder="Select status"
                          options={statusOptions}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* ===== Partnership Configuration (optional) ===== */}
                {/* {showPartnership && (
                  <div className="row g-4 mt-3">
                    <div className="col-lg-12">
                      <div className="rounded-4 p-3">
                        <h5 className="fw-semibold text-dark border-bottom pb-2 mb-3">Partnership Configuration</h5>
                        <div className="text-muted mb-3" style={{ fontSize: 13 }}>
                          Select the brokerages and agents that will be associated with this brand.
                        </div>
                        <div className="mb-3" style={{ maxWidth: 720 }}>
                          <label className="form-label">Select Brokerages</label>
                          <Select
                            name="__brokerages"
                            isMulti
                            options={brokerageOptions}
                            value={selectedBrokerages}
                            onChange={(vals) =>
                              onChangeBrokerages?.((vals as MultiValue<SelectOption>) as SelectOption[])
                            }
                            placeholder="Choose brokerages"
                          />

                          <div className="d-flex align-items-center justify-content-between mt-2">
                            <div className="small text-muted">Selected Brokerages ({selectedBrokerages.length})</div>
                            <button type="button" className="btn btn-link p-0 small" onClick={onClearAllBrokerages}>
                              <i className="bi bi-trash me-1" /> Clear All
                            </button>
                          </div>
                          {!!selectedBrokerages.length && (
                            <div className="d-flex flex-wrap gap-2 mt-2">
                              {selectedBrokerages.map((o) => (
                                <span key={o.value} className="badge rounded-pill bg-body-tertiary text-secondary-emphasis px-3 py-2">
                                  {o.label}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="mb-3" style={{ maxWidth: 720 }}>
                          <label className="form-label">Select Agents</label>
                          <Select
                            name="__agents"
                            isMulti
                            options={agentOptions}
                            value={selectedAgents}
                            onChange={(vals) =>
                              onChangeAgents?.((vals as MultiValue<SelectOption>) as SelectOption[])
                            }
                            placeholder="Choose agents"
                          />

                          <div className="d-flex align-items-center justify-content-between mt-2">
                            <div className="small text-muted">Selected Agents ({selectedAgents.length})</div>
                            <button type="button" className="btn btn-link p-0 small" onClick={onClearAllAgents}>
                              <i className="bi bi-trash me-1" /> Clear All
                            </button>
                          </div>
                          {!!selectedAgents.length && (
                            <div className="d-flex flex-wrap gap-2 mt-2">
                              {selectedAgents.map((o) => (
                                <span key={o.value} className="badge rounded-pill bg-body-tertiary text-secondary-emphasis px-3 py-2">
                                  {o.label}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="mb-3" style={{ maxWidth: 720 }}>
                          <label className="form-label">Select Groups</label>
                          <Select
                            name="__groups"
                            isMulti
                            options={groupOptions}
                            value={selectedGroups}
                            onChange={(vals) =>
                              onChangeGroups?.((vals as MultiValue<SelectOption>) as SelectOption[])
                            }
                            placeholder="Choose groups"
                          />

                          <div className="d-flex align-items-center justify-content-between mt-2">
                            <div className="small text-muted">Selected Groups ({selectedGroups.length})</div>
                            <button type="button" className="btn btn-link p-0 small" onClick={onClearAllGroups}>
                              <i className="bi bi-trash me-1" /> Clear All
                            </button>
                          </div>
                          {!!selectedGroups.length && (
                            <div className="d-flex flex-wrap gap-2 mt-2">
                              {selectedGroups.map((o) => (
                                <span key={o.value} className="badge rounded-pill bg-body-tertiary text-secondary-emphasis px-3 py-2">
                                  {o.label}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="mt-3" style={{ maxWidth: 760 }}>
                          <div className="p-3 rounded-3" style={{ background: "#f3f7ff", border: "1px solid #cfe0ff" }}>
                            {partnershipLoading ? (
                              <div className="text-muted">Loading…</div>
                            ) : (
                              <>
                                <div className="fw-semibold mb-1">Partnership Summary</div>
                                <ul className="m-0 ps-3">
                                  <li>{(partnershipSummary?.brokeragesCount ?? 0)} brokerages selected</li>
                                  <li>{(partnershipSummary?.agentsCount ?? 0)} agents selected</li>
                                  <li>{(partnershipSummary?.groupsCount ?? 0)} groups selected</li>
                                </ul>
                                <div className="mt-2 fw-semibold">
                                  Total partnerships: {partnershipSummary?.total ?? 0}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}

                {showPartnership && (
                  <div className="row g-4 pc-section">
                    <div className="col-lg-12">
                      <div className="rounded-4 p-3">

                        <h5 className="pc-title">Partnership Configuration</h5>
                        <div className="pc-subtext">
                          Select the brokerages and agents that will be associated with this brand.
                        </div>

                        {/* Select Brokerages */}
                        <div className="mb-3 col-lg-6">
                          <label className="form-label pc-label">Select Brokerages</label>

                          <Select
                            name="__brokerages"
                            isMulti
                            options={brokerageOptions}
                            value={selectedBrokerages}
                            onChange={(vals) =>
                              onChangeBrokerages?.((vals as MultiValue<SelectOption>) as SelectOption[])
                            }
                            placeholder="Choose brokerages"
                            styles={pcSelectStyles}
                             components={{ DropdownIndicator }}
                            classNamePrefix="rs"
                          />

                          <div className="d-flex align-items-center justify-content-between mt-2">
                            <div className="small text-muted">
                              Selected Brokerages ({selectedBrokerages.length})
                            </div>
                            <button type="button" className="btn btn-link p-0 pc-clear" onClick={onClearAllBrokerages}>
                              <i className="bi bi-trash me-1" /> Clear All
                            </button>
                          </div>

                          {!!selectedBrokerages.length && (
                            <div className="d-flex flex-wrap gap-2 mt-2">
                              {selectedBrokerages.map((o) => (
                                <span key={o.value} className="pc-chip">{o.label}</span>
                              ))}
                            </div>
                          )}
                        </div>

                        {/* Select Agents */}
                        <div className="mb-3 col-lg-6">
                          <label className="form-label pc-label">Select Agents</label>

                          <Select
                            name="__agents"
                            isMulti
                            options={agentOptions}
                            value={selectedAgents}
                            onChange={(vals) =>
                              onChangeAgents?.((vals as MultiValue<SelectOption>) as SelectOption[])
                            }
                            placeholder="Choose agents"
                            styles={pcSelectStyles}
                            components={{ DropdownIndicator }}
                            classNamePrefix="rs"
                          />

                          <div className="d-flex align-items-center justify-content-between mt-2">
                            <div className="small text-muted">
                              Selected Agents ({selectedAgents.length})
                            </div>
                            <button type="button" className="btn btn-link p-0 pc-clear" onClick={onClearAllAgents}>
                              <i className="bi bi-trash me-1" /> Clear All
                            </button>
                          </div>

                          {!!selectedAgents.length && (
                            <div className="d-flex flex-wrap gap-2 mt-2">
                              {selectedAgents.map((o) => (
                                <span key={o.value} className="pc-chip">{o.label}</span>
                              ))}
                            </div>
                          )}
                        </div>

                        {/* Select Groups */}
                        <div className="mb-3 col-lg-6">
                          <label className="form-label pc-label">Select Groups</label>

                          <Select
                            name="__groups"
                            isMulti
                            options={groupOptions}
                            value={selectedGroups}
                            onChange={(vals) =>
                              onChangeGroups?.((vals as MultiValue<SelectOption>) as SelectOption[])
                            }
                            placeholder="Choose groups"
                            styles={pcSelectStyles}
                            components={{ DropdownIndicator }}
                            classNamePrefix="rs"
                          />

                          <div className="d-flex align-items-center justify-content-between mt-2">
                            <div className="small text-muted">
                              Selected Groups ({selectedGroups.length})
                            </div>
                            <button type="button" className="btn btn-link p-0 pc-clear" onClick={onClearAllGroups}>
                              <i className="bi bi-trash me-1" /> Clear All
                            </button>
                          </div>

                          {!!selectedGroups.length && (
                            <div className="d-flex flex-wrap gap-2 mt-2">
                              {selectedGroups.map((o) => (
                                <span key={o.value} className="pc-chip">{o.label}</span>
                              ))}
                            </div>
                          )}
                        </div>

                        {/* Summary */}
                        <div className="mt-3" style={{ maxWidth: 760 }}>
                          <div className="pc-summary">
                            {partnershipLoading ? (
                              <div className="text-muted">Loading…</div>
                            ) : (
                              <>
                                <div className="fw-semibold mb-1">Partnership Summary</div>
                                <ul className="m-0 ps-3">
                                  <li>{(partnershipSummary?.brokeragesCount ?? 0)} brokerages selected</li>
                                  <li>{(partnershipSummary?.agentsCount ?? 0)} agents selected</li>
                                  <li>{(partnershipSummary?.groupsCount ?? 0)} groups selected</li>
                                </ul>
                                <div className="mt-2 fw-semibold">
                                  Total partnerships: {partnershipSummary?.total ?? 0}
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                )}


                {/* ===== Footer ===== */}
                <div className="row g-4 mt-3">
                  <div className="col-lg-12">
                    <div className="rounded-4 p-3">
                      <hr className="" />
                      <div className="d-flex justify-content-between align-items-center py-4" >
                        <button type="button" onClick={onBack} className="btn back-btn surface-btn fw-bold fs-16">
                          <i className="bi bi-chevron-left me-2" /> Back
                        </button>
                        <button type="submit" className="btn btn-primary save-btn surface-btn fw-bold fs-16" disabled={submitting}>
                          {submitting ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <style>
              {`
               .pc-section .pc-title {
  color: #111827; font-size: 16px;
  border-bottom: 1px solid #eef2f7; padding-bottom: 10px; margin-bottom: 12px;
}
.pc-section .pc-subtext { color: #6b7280; font-size: 13px; margin-bottom: 14px; }
.pc-section .pc-label   { font-size: 13px; margin-bottom: 6px; }

.pc-chip {
  background:#eef2ff; border:1px solid #dbeafe; color:#1e3a8a;
  border-radius:9999px; font-weight:500; font-size:12px; padding:6px 12px;
}
.pc-summary {
  background:#f3f7ff; border:1px solid #cfe0ff; border-radius:12px; padding:14px;
}
.pc-clear { font-size:12px; color:#6b7280; }
.pc-clear:hover { color:#e7000b; }
.pc-clear i { vertical-align: -2px; }

              `}
            </style>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignageBrandCategoryForm;
